/* eslint-disable indent */
import { Link } from 'react-router-dom';
import LinkButton from '../../../../../components/Buttons/LinkButton/LinkButton';
import './style.scss';
import { SYSTEM_PATH } from '../../../../../core/configs/constants';
import { observer } from 'mobx-react';
import { ChevronRight } from 'lucide-react';
import { useStore } from '../../../../../core/utils/hook';
import { BannerImg1, BannerImg2 } from './ImgBanner';

const BannerTopPage = observer(() => {
    // store
    const {
        settingTopPageStore: { isPreview }
    } = useStore();

    return (
        <section className="banner-new">
            <div className="banner-curve">
                {/* <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1440 132"
                        preserveAspectRatio="none"
                    >
                        <path d="" fill="" />
                    </svg> */}

                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1440 134"
                    preserveAspectRatio="none"
                >
                    <path d="M0,124 C480,-10 960,-10 1440,124 L1440,134 L0,134 Z" fill="" />
                </svg>
            </div>

            <div className='container'>
                <div className='banner-wrapper'>
                    {/* Img-text mobile */}
                    {/* <img
                            src="/images/banner-img-2.png"
                            alt="banner"
                            className="img-text-mobile"
                        /> */}
                    <BannerImg2 className='img-text-mobile' />

                    {/* <img
                            src="/images/banner-img-1.png"
                            alt="banner"
                            className="banner-img"
                        /> */}
                    <img
                        src="/images/banner-img-cus-2.png"
                        alt="banner"
                        className="banner-img"
                    />
                    {/* <BannerImg1 className='banner-img' /> */}

                    <div className='content'>
                        {/* <img
                                src="/images/banner-img-2.png"
                                alt="banner"
                                className="img-text"
                            /> */}
                        <BannerImg2 className='img-text' />

                        <div className='content-with-button'>
                            <div className='text-banner'>新規登録・法人契約ご希望の方はこちらから</div>
                            <div className='banner-button'>
                                <LinkButton
                                    href={isPreview ? undefined : SYSTEM_PATH.REGISTRATION_FIRST_STEP}
                                    onClick={(e) => {
                                        if (isPreview) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    新規登録
                                </LinkButton>
                                <LinkButton
                                    href={isPreview ? undefined : `${SYSTEM_PATH.SEND_INQUIRY}?category=7`}
                                    onClick={(e) => {
                                        if (isPreview) {
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }}
                                >
                                    法人契約の問い合わせ
                                </LinkButton>
                            </div>
                        </div>

                        {/* Content link pc */}
                        <div className='content-position'>
                            <div className='content-link'>
                                <div className='text-banner'>
                                    公益財団法人日本薬剤師研修センター（G01）のPECS（薬剤師研修・認定電子システム）対応
                                </div>
                                <div className='text-banner'>
                                    <div>
                                        ※単位申請にはPECSの事前登録が必要です。
                                        <Link
                                            to={isPreview ? undefined : 'https://pecs.jpec.or.jp/_/pharmacist/'}
                                            target='_blank'
                                            className='link-text'
                                            onClick={(e) => {
                                                if (isPreview) {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                }
                                            }}
                                        >
                                            PECSの登録はこちら
                                            <ChevronRight size={16} strokeWidth={2} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Content link mobile */}
                        <div className='content-link-mobile'>
                            <div className='text-banner'>
                                公益財団法人日本薬剤師研修センター（G01）の
                                <br />
                                PECS（薬剤師研修・認定電子システム）対応
                            </div>
                            <div className='text-banner'>
                                <div>
                                    ※単位申請にはPECSの事前登録が必要です。
                                    <br />
                                    <Link
                                        to={isPreview ? undefined : 'https://pecs.jpec.or.jp/_/pharmacist/'}
                                        target='_blank'
                                        className='link-text'
                                        onClick={(e) => {
                                            if (isPreview) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                            }
                                        }}
                                    >
                                        PECSの登録はこちら
                                        <ChevronRight size={16} strokeWidth={2} />
                                    </Link>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </section>
    );
});

export default BannerTopPage;
